/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  order.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:32
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import { axiosAPIUrl, Parameter } from "./index"
import { AppendixFileDto } from '@/api/commonConfig'

/* 订货单列表查询参数类型 */
export class OrderParamsDTO {
  companyId?: string;
  orderStatusList?: number[];
  orderStatus?:number[];
  startTime?: string;
  endTime?: string;
  orderId?: string;
  currRouteId?: number;
  orderType?: number | string;
  payStatus?: number | string;
  maintainId?: string;
  orderby?: string;
  pageIndex?: number;
  pageSize?: number;
  authorityNode?: number
}

/* 订货单列表数据类型 */
export class OrderListDto {
  /* 订单编号 */
  orderId?: string;
  /* 下单时间 */
  createTime?: string;
  // 客户编码（买方公司）
  customerId?: string;
  // 客户名称
  customerName?: string;
  // 客户等级
  customerLever?: string;
  // 客户等级描述
  customerLeverName?: string;
  // 金额
  orderMoney?: number;
  // 状态（1待订单审核 2待出库确认 3发货确认 4待收货确认 5已完成 6已作废）
  orderStatus?: number;
  // 订货单状态
  orderStatusName?: string;
  // 付款状态（1未付款 2已付款）
  payStatus?: number;
  // 付款状态描述
  payStatusName?: string;
  // 交货日期
  deliveryDate?: string;
  // 公司编号
  companyId?: string;
  // 下单方式（1商家下单 2代客下单）
  orderType?: number;
  // 下单方式描述
  orderTypeName?: string;
  // 业务员
  maintainId?: string;
  // 收货地址id
  receiveAddress?: string;
  // 收货地址中文描述
  addressFullName?: string;
  // 收货地址明细
  receiveAddressDtl?: string;
  // 收货人手机
  receiveMobile?: string;
  // 收货人
  receiveMan?: string;
  // 附件列表
  orderFile?:AppendixFileDto[]
  // 备注
  orderRemark?: string;
  // 运费
  payFreight?: string;
  // 配送方式
  distributionWay?: number;
  // 配送方式
  distributionWayName?: string;
  // 订单数量合计
  orderAmount?: number;
  // 订单总额
  orderTotalMoney?: number;
  // 完成时间
  updateTime?: string;
  // 分区序号
  currRouteId?: number;
  // 是否可退货
  returnable?: boolean;
  // 商品清单
  orderDtlList?: Array<any>
  // 备注列表
  orderRemarkList?: Array<any>
}

/* 订货单详情数据类型 */
export class ShopOrderInfoDto {
  // 配送方式
  distributionWay?: number;
  // 配送方式
  distributionWayName?: string;
  /* 卖方企业编号 */
  shopCompanyId?: string;
  /* 卖方企业Logo */
  shopCompanyLogo?: string;
  /* 卖方企业名 */
  shopCompanyName?: string;
  /* 订单编号 */
  orderId?: string;
  /* 下单时间 */
  createTime?: string;
  /* 是否代下单 */
  orderType?: number;
  /* 应付金额 */
  orderMoney?: number;
  /* 订货单状态 */
  orderStatus?: number;
  /* 订货单状态中文描述 */
  orderStatusName?: string;
  /* 付款状态 */
  payStatus?: number;
  /* 付款状态中文描述 */
  payStatusName?: string;
  /* 运费 */
  payFreight?: number;
  /* 订单金额合计 */
  orderTotalMoney?: number;
  /* 套餐种类合计 */
  packageCateAmount?: number;
  /* 套餐数量合计 */
  packageTotalQuantity?: number;
  /* 交货日期 */
  deliveryDate?: string;
  /* 附件名称 */
  orderFileName?: string;
  /* 附件URL */
  orderFileUrl?: string;
  /* 收货地址 */
  receiveAddress?: string;
  /* 收货地址描述 */
  addressFullName?: string;
  /* 收货地址明细 */
  receiveAddressDtl?: string;
  /* 收货人手机 */
  receiveMobile?: string;
  /* 收货人 */
  receiveMan?: string;
  /* 分区序号 */
  currRouteId?: number;
  /* 是否可退货 */
  returnable?: boolean;
  /* 订单备注列表 */
  orderRemarkList?: any[];
  /* 订单明细列表 */
  // orderDtlList?: ShopOrderDtlListDto[];
  orderDtlList?: any[];
}

/* 退货单列表查询参数类型 */
export class OrderReturnParamsDTO {
  companyId?: string;
  returnOrderStatusList?: number[];
  returnOrderStatus?: number[]
  startTime?: string;
  endTime?: string;
  returnOrderId?: string;
  currRouteId?: number;
  orderId?: string;
  returnOrderType?: number | string;
  returnPayStatus?: number | string;
  maintainId?: string;
  orderby?: string;
  pageIndex?: number;
  pageSize?: number;
  authorityNode?: number
}


/* 退货单列表数据类型 */
export class OrderReturnDto {
  /* 订单编号 */
  orderId?: string;
  // 退订单编号
  returnOrderId?: string;
  /* 退单时间 */
  createTime?: string;
  // 客户编码（买方公司）
  customerId?: string;
  // 客户名称
  customerName?: string;
  // 客户等级
  customerLever?: string;
  // 客户等级描述
  customerLeverName?: string;
  // 退单金额
  returnMoney?: number;
  // 退单状态（1待退单审核 2待收货确认 3待退款审核 4待收款确认 5已完成 6已作废）
  returnOrderStatus?: number;
  // 退货单状态
  returnOrderStatusName?: string;
  // 退款状态（1退款中 2已退款）
  returnPayStatus?: number;
  // 退款状态描述
  returnPayStatusName?: string;
  // 公司编号
  companyId?: string;
  // 退单方式（1商家退单 2代客退单）
  returnOrderType?: number;
  // 退单方式描述
  returnOrderTypeName?: string;
  // 业务员
  maintainId?: string;
  // 退款人开户行
  returnManBank?: string;
  // 退款人银行卡
  receiveManBankNo?: string;
  // 退款人手机号
  returnManMobile?: string;
  // 退款人
  returnMan?: string;
  // 附件路径
  orderFileUrl?: string;
  // 附件名称
  orderFileName?: string;
  // 附件大小
  orderFileSize?: string;
  // 备注
  orderRemark?: string;
  // 运费
  payFreight?: string;
  // 配送方式
  distributionWay?: number;
  // 订单数量合计
  returnOrderAmount?: number;
  // 获批退款金额（可修改）
  returnMoneySum?: number;
  // 分区序号
  currRouteId?: number;
}

/* 销售单订货单列表数据类型 */
export class ShopOrderListDto {
  /* 订单编号 */
  orderId?: string;
  /* 下单时间 */
  createTime?: string;
  /* 卖方企业编号 */
  shopCompanyId?: string;
  /* 卖方企业Logo */
  shopCompanyLogo?: string;
  /* 卖方企业名 */
  shopCompanyName?: string;
  /* 是否代下单 */
  orderType?: number;
  /* 应付金额 */
  orderMoney?: number;
  /* 订货单状态 */
  orderStatus?: number;
  /* 订货单状态中文描述 */
  orderStatusName?: string;
  /* 付款状态 */
  payStatus?: number;
  /* 付款状态中文描述 */
  payStatusName?: string;
  /* 套餐种类合计 */
  packageCateAmount?: number;
  /* 套餐数量合计 */
  packageTotalQuantity?: number;
  /* 分区序号 */
  currRouteId?: number;
}

/* 销售单退货单列表数据类型 */
export class ReturnOrderListDto {
  returnOrderId?: string;
  createTime?: string;
  shopCompanyId?: string;
  shopCompanyLogo?: string;
  shopCompanyName?: string;
  returnOrderType?: number;
  returnOrderMoney?: number;
  returnMoneySum?: number;
  returnOrderStatus?: number;
  returnOrderStatusName?: string;
  returnPayStatus?: string;
  returnPayStatusName?: string;
  packageCateAmount?: number;
  packageTotalQuantity?: number;
  currRouteId?: number;
}

/* 附件修改 2.0需求删除改接口*/
export function modifyOrderAttachFile (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<Ajax.ListData<OrderListDto>>>({
    url: "/cykjorder/OM/modifyOrderAttachFile",
    method: "post",
    data: parameter,
  });
}

// 采购单订货单
/* 获取订货单列表 */
export function getOrderInfoListApp(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<Ajax.ListData<ShopOrderListDto>>>({
      url: "/cykjorder/lookUp/getOrderInfoList",
      method: "post",
      data: parameter,
  });
}

// 销售单订货单
/* 获取订货单列表 */
export function getPurchaseOrderListApp (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<Ajax.ListData<OrderListDto>>>({
    url: "/cykjorder/lookUp/getPurchaseOrderListApp",
    method: "post",
    data: parameter,
  });
}

/* 修改订货单状态 */
export function updateOrderStatus (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<Ajax.ListData<OrderListDto>>>({
    url: "/cykjorder/OM/updateOrderStatus",
    method: "post",
    data: parameter,
  });
}

/* 修改订货单付款状态 */
export function updateOrderPayStatus (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<Ajax.ListData<OrderListDto>>>({
    url: "/cykjorder/OM/updateOrderPayStatus",
    method: "post",
    data: JSON.stringify({...parameter}),
  });
}

// 采购单退货单
/* 获取退货单列表 */
export function getReturnOrderList(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<Ajax.ListData<ReturnOrderListDto>>>({
      url: "/cykjorder/lookUp/getReturnOrderList",
      method: "post",
      data: parameter,
  });
}

// 销售单退货单
/* 获取退货单列表 */
export function getReturnOrderListApp (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<Ajax.ListData<OrderListDto>>>({
    url: "/cykjorder/RO/getReturnOrderListApp",
    method: "post",
    data: parameter,
  });
}

/* 修改退货单状态 */
export function updateReturnOrderStatus (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<Ajax.ListData<OrderListDto>>>({
    url: "/cykjorder/RO/updateReturnOrderStatus",
    method: "post",
    data: parameter,
  });
}

/* 获取订货/退货处理流程 */
export function getOrderNodeList (parameter: Parameter = {}, showLoading = true) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjorder/OS/getOrderNodeList",
    method: "post",
    data: parameter,
    extraParams: {
      showLoading: showLoading
    }
  });
}

/* 获取下单时订货/退货处理流程 */
export function getOrderOrReturnNodeList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjorder/OS/getOrderOrReturnNodeList",
    method: "post",
    data: parameter,
  });
}
/* 发起退货入参退货单明细列表数据类型 */
export class ReturnOrderDtlParamsApi {
  orderDtlId?: string;
  returnAmount?: number;
  returnMoney?: number;
  returnOrderDtlRemark?: string;
}

/* 订货单明细查询返回数据 */
export class OrderDtlApi {
  /* 客户编码(买方公司) */
  customerId?: string;
  /* 客户名称 */
  customerName?: string;
  /* 客户等级 */
  customerLever?: number;
  /* 客户等级描述 */
  customerLeverName?: string;
  /*  */
  orderId?: string;
  /*  */
  createTime?: string;
  /* orderType （1商家下单 2代客下单） */
  orderType?: number;
  /* 应付金额 */
  orderMoney?: number;
  /* 订货单状态 */
  orderStatus?: string;
  /* 订货单状态中文描述 */
  orderStatusName?: string;
  /* 付款状态 */
  payStatus?: string;
  /* 付款状态中文描述 */
  payStatusName?: string;
  /* 运费 */
  payFreight?: number;
  /* 订单备注 */
  orderRemark?: string;
  /* 订单金额合计 */
  orderTotalMoney?: number;
  /* 套餐种类合计 */
  packageCateAmount?: number;
  /* 套餐数量合计 */
  packageTotalQuantity?: number;
  /* 交货日期 */
  deliveryDate?: number;
  orderFileList?:AppendixFileDto[]
  /* 收货地址 */
  receiveAddress?: string;
  /* 收货地址明细 */
  receiveAddressDtl?: string;
  /* 收货人手机 */
  receiveMobile?: string;
  /* 收货人 */
  receiveMan?: string;
  /* 分区序号 */
  currRouteId?: number;
  /* 订单备注列表 */
  orderRemarkList?: { remarkPersonName?: string; orderRemark?: string; createTime?: string; }[];
  orderDtl?: OrderDtlResApi[];
}

export class OrderDtlResApi {
  /* 订单明细编号 */
  orderDtlId?: string;
  /* 版本编号 */
  versionId?: string;
  /* 公司编号 */
  companyId?: string;
  /* 订单号 */
  orderId?: string;
  /* 商品编号 */
  goodsId?: string;
  /* 商品编码 */
  goodsCode?: string;
  /* 套餐编号 */
  setmealId?: string;
  /* 单价 */
  salePrice?: number;
  /* 数量 */
  saleAmount?: number;
  /* 退单数量 （退单模块使用） */
  returnAmount?: number;
  /* 可退货数量 */
  returnSaleAmount?: number;
  /* 订单金额 */
  orderMoney?: number;
  /* 订单详情备注 */
  orderDtlRemark?: string;
  /* 商品名称 */
  goodsName?: string;
  /* 规格名称 */
  packageNameDesc?: string;
  /* 商品主图url */
  goodsMainImage?: string;
  /* 套餐主图url */
  packageMainImage?: string;
  /* 商品品牌名称 */
  brandName?: string;
  /* 分区序号 */
  currRouteId?: number;
  /* 是否选中 */
  isChecked?: boolean;
}

/* 订货单明细查询 */
export function getPurchaseOrderDtlList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjorder/lookUp/getPurchaseOrderDtlList",
    method: "post",
    data: parameter,
  });
}

/* 发起退货 */
export function launchReturnOrder (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: "/cykjorder/RO/launchReturnOrder",
    method: "post",
    data: parameter,
  });
}

/* 日志页数据类型 */
export class LogListApi {
  /* 节点id */
  orderNodeId?: number;
  /* 备注 */
  orderRemark?: number;
  /* 创建者 */
  createUser?: number;
  /* 创建时间 */
  createTime?: number;
  /* 公司名字 */
  companyName?: number;
  /* 标题 */
  nodeTitle?: number;
}

/* 获取操作节点日志 */
export function getOperateLog (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<{ nodeRecord?: LogListApi[] }>>({
    url: "/cykjorder/lookUp/getOperateLog",
    method: "post",
    data: parameter,
  });
}


export class RemarkListDTO {
  // 订单编号
  orderId?: string;
  // 公司编号
  companyId?: string;
  // 公司名称
  companyName?: string;
  // 公司logo
  logoUrl?: string;
  // 订单类型
  orderType?: number;
  // 订单备注
  orderRemark?: string;
  // 创建人名字
  createUser?: string;
  // 创建人名字
  createTime?: string;
}

/* 获取订/退单备注页 */
export function getOrderRemarkList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<{ orderRemark?: RemarkListDTO[] }>>({
    url: "/cykjorder/lookUp/getOrderRemarkList",
    method: "post",
    data: parameter,
  });
}

// 修改订单
export function modifyOrder (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjorder/OM/modifyOrder",
    method: "post",
    data: parameter,
  });
}

// 退回订货单
export function backOrder (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjorder/OM/backOrder",
    method: "post",
    data: parameter,
  });
}

// 退回退货单
export function backReturnOrder (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjorder/RO/backReturnOrder",
    method: "post",
    data: parameter,
  });
}

/* 获取销售单订货单详情 */
export function getOrderInfoApp (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjorder/lookUp/getOrderInfoApp",
    method: "post",
    data: parameter,
  });
}

/* 获取采购单订货单详情 */
export function getOrderInfo (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjorder/lookUp/getOrderInfo",
    method: "post",
    data: parameter,
  });
}

/* 退货单明细查询返回数据 */
export class OrderReturnDtlApi {
  shopCompanyId?: string;
  /* 客户编码(买方公司) */
  customerId?: string;
  /* 客户名称 */
  customerName?: string;
  /* 客户等级 */
  customerLever?: number;
  /* 客户等级描述 */
  customerLeverName?: string;
  /* 订单关联编号 */
  orderId?: string;
  /* 退单编号 */
  returnOrderId?: string;
  /* 创建时间 */
  createTime?: string;
  /* 完成时间 */
  updateTime?: string;
  /* 是否代下单 （1商家下单 2代客下单） */
  returnOrderType?: number;
  /* 获批退款金额（可修改） */
  returnMoneySum?: number;
  /* 订货单状态 */
  returnOrderStatus?: number;
  /* 订货单状态中文描述 */
  returnOrderStatusName?: string;
  /* 退款状态 */
  returnPayStatus?: string;
  /* 付款状态中文描述 */
  returnPayStatusName?: string;
  /* 退单备注 */
  orderRemark?: string;
  /* 退单金额合计 */
  returnOrderMoney?: number;
  /* 套餐种类合计 */
  packageCateAmount?: number;
  /* 套餐数量合计 */
  packageTotalQuantity?: number;
  /* 退款人姓名 */
  returnMan?: string;
  /* 退款人开户行 */
  returnManBank?: string;
  /* 退款人手机号 */
  returnManMobile?: string;
  /* 退款人银行卡 */
  receiveManBankNo?: string;
  /* 分区序号 */
  currRouteId?: string;
  /* 退单备注列表 */
  returnOrderRemarkList?: { name?: string; orderRemark?: string; createTime?: string; }[];
  orderDtlList?: OrderDtlResApi[];
  /* 退单附件列表 */
  orderFileList?: AppendixFileDto[];
  /* 退单附件列表 */
  orderFile?: AppendixFileDto[];
}

/* 获取销售单退货单详情 */
export function getOrderReturnInfoApp (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<OrderReturnDtlApi>>({
    url: "/cykjorder/RO/getReturnOrderInfoApp",
    method: "post",
    data: parameter,
  });
}

/* 获取采购单退货单详情 */
export function getReturnOrderInfo (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<OrderReturnDtlApi>>({
    url: "/cykjorder/lookUp/getReturnOrderInfo",
    method: "post",
    data: parameter,
  });
}

/* 修改退货单 */
export function modifyReturnOrder (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: "/cykjorder/RO/modifyReturnOrder",
    method: "post",
    data: parameter,
  });
}

export class PurchaseOrderDtlListOrderDto {
  versionId?: string;
  goodsId?: string;
  setmealId?: string;
  saleAmount?: number;

}

/* 代客订货单新增 */
export function addPurchaseOrder (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: "/cykjorder/OM/addPurchaseOrder",
    method: "post",
    data: parameter,
  });
}

export class OrderAgainDto {
  /* 客户编码(买方公司) */
  customerId?: string;
  /* 客户名称 */
  customerName?: string;
  /* 客户等级 */
  customerLever?: number;
  /* 客户等级描述 */
  customerLeverName?: string;
  /* 配送方式 */
  distributionWay?: string;
  /* 配送方式描述 */
  distributionWayName?: string;
  /* 应付金额 */
  orderMoney?: number;
  /* 运费 */
  payFreight?: number
  /* 套餐种类合计 */
  packageCateAmount?: number;
  /* 套餐数量合计 */
  packageTotalQuantity?: number;
  /* 收货地址id */
  receiveAddress?: string;
  /* 收货地址描述 */
  addressFullName?: string;
  /* 收货地址明细 */
  receiveAddressDtl?: string;
  /* 收货人手机号 */
  receiveMobile?: string;
  /* 收货人 */
  receiveMan?: string;
  /* 订单明细 */
  orderDtlList?: OrderDtlResApi[];
}

/* 再来一单 */
export function purchaseOrderAgainAppApi (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: "/cykjorder/lookUp/purchaseOrderAgainApp",
    method: "post",
    data: parameter,
  });
}
